import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
import { scrollToOffer } from '../utils/scroll';
export function GuaranteeSection() {
  const bullets = ['Nessun rischio per te', 'Rimborso completo del 100%', 'Senza fare domande', 'Procedura semplice via email'];
  return <section className="py-16 md:py-24 px-4 bg-gray-50 overflow-hidden" data-id="element-105">
      <div className="max-w-4xl mx-auto relative" data-id="element-106">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-64 h-64 bg-blue-400/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-107"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-green-400/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" data-id="element-108"></div>

        <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 md:p-12 relative z-10 flex flex-col md:flex-row items-center gap-10" data-id="element-109">
          {/* Left: Visual Seal */}
          <div className="w-full md:w-1/3 flex justify-center" data-id="element-110">
            <div className="relative w-48 h-48 flex items-center justify-center" data-id="element-111">
              <div className="absolute inset-0 border-4 border-dashed border-blue-200 rounded-full animate-spin-slow" data-id="element-112"></div>
              <div className="absolute inset-2 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full flex flex-col items-center justify-center text-white shadow-inner" data-id="element-113">
                <ShieldCheckIcon className="w-16 h-16 mb-2" data-id="element-114" />
                <span className="font-bold text-center leading-tight" data-id="element-115">
                  45 GIORNI
                  <br data-id="element-116" />
                  GARANZIA
                </span>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-117">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-118">
              Garanzia di Soddisfazione 100%
            </h2>
            <p className="text-lg text-gray-600 mb-6" data-id="element-119">
              Prova il MegaPack Maestro Musicale 360° in totale tranquillità.
              Hai 45 giorni di garanzia per valutare il materiale senza alcun
              rischio.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-120">
              {bullets.map((bullet, i) => <div key={i} className="flex items-center gap-2 justify-center md:justify-start" data-id="element-121">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-122" />
                  <span className="text-gray-800 font-medium" data-id="element-123">{bullet}</span>
                </div>)}
            </div>

            <button onClick={scrollToOffer} className="bg-blue-600 hover:bg-blue-700 text-white rounded-full py-4 px-8 font-bold text-lg shadow-md transition-colors" data-id="element-124">
              🔵 Prova senza rischi
            </button>
          </div>
        </div>
      </div>
    </section>;
}